import { render, staticRenderFns } from "./Grid1.vue?vue&type=template&id=43327e1d&scoped=true"
import script from "./Grid1.vue?vue&type=script&lang=ts"
export * from "./Grid1.vue?vue&type=script&lang=ts"
import style0 from "./Grid1.vue?vue&type=style&index=0&id=43327e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43327e1d",
  null
  
)

export default component.exports